<template>
  <div>
    <b-jumbotron id="kub-completion-msg" header-tag="h2" header-level="4" :header="completion.header" :lead="completion.lead">
      <p>
        {{completion.msg}}
      </p>
      <b-button class="kub-btn-filled mr-2" @click="reloadPage()">
        <b-icon :icon="completion.btnReload.icon" class="mr-2" font-scale="1"></b-icon>
        <span id="kub-completion-btnReload-text">{{completion.btnReload.text}}</span>
        <span id="kub-completion-btnReload-textShort">{{completion.btnReload.textShort}}</span>
      </b-button>
      <b-button class="kub-btn-filled ml-2" :href="homepage">
        <b-icon :icon="completion.btnShop.icon" class="mr-2" font-scale="1"></b-icon>
        <span>{{completion.btnShop.text}}</span>
      </b-button>
    </b-jumbotron>
  </div>
</template>

<script>
import DataCompletion from '../../../data/main/completion/completion'
import DataContact from '../../../data/general/contact'

export default {
  data () {
    return {
      completion: DataCompletion.completion,
      homepage: DataContact.contact.homepage.content
    }
  },
  methods: {
    reloadPage () {
      window.location.reload()
    }
  }
}
</script>

<style scoped>
  h2 {
    font-size: 3rem !important;
  }

  #kub-completion-msg {
    height:100vh;
    background-color: rgba(0, 0, 0, 0.03);
  }

  #kub-completion-btnReload-textShort {
    display: none;
  }

  @media (max-width: 340px) {
    #kub-completion-btnReload-text {
      display: none;
    }
    #kub-completion-btnReload-textShort {
      display: inline;
    }
  }
</style>
